// ets_tracing: off
export const isIn = keys => k => k in keys;
//# sourceMappingURL=index.mjs.map